import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App.js';
// import App from './App.test.js';

// Redirect from any domain that's not the correct one BEFORE React loads
// Skip redirect for localhost development
if (typeof window !== "undefined" && 
    window.location.hostname !== "timesheet.billbergia.com.au" && 
    !window.location.hostname.includes("localhost") && 
    window.location.hostname !== "127.0.0.1") {
    // Add cache-busting parameter to force fresh load
    const separator = window.location.search ? '&' : '?';
    const cacheBuster = `${separator}v=${Date.now()}`;
    const newUrl = 'https://timesheet.billbergia.com.au' + 
                   window.location.pathname + 
                   window.location.search + 
                   cacheBuster +
                   window.location.hash;
    window.location.replace(newUrl);
    // Stop execution - don't load React app
    throw new Error("Redirecting to correct domain");
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
